import ListingFinancialsEditor from './ListingFinancialsEditor.component';

export default ListingFinancialsEditor;
